import React, { useState, useCallback } from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


function CmsElementAccordion(props) {
  const { index, children, showElementSettings } = props;

  // --- Local State ---
  const [shown, setShown] = useState(false);
  const [shownAccordionIndex, setShownAccordionIndex] = useState(null);

  // --- Abstract Logic Hook ---
  const {
    getMainId,
    getCssClasses,
    getElementStyle,
    getBackgroundStyle,
    getParamValue,
    getParallaxData,
    getCustomId,
    getAppendHtml,
  } = useAbstractCmsElement(props);

  // --- dnd-kit Integration ---
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: index });

  const dndStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    cursor: isDragging ? 'grabbing' : 'default',
  };

  // --- Handlers ---
  const handleShown = useCallback(() => {
    setShown(true);
  }, []);

  const handleShowAccordion = useCallback((newIndex) => {
    setShownAccordionIndex(newIndex);
  }, []);

  const handleShowSettings = (e) => {
    // Prevents triggering when pulling, if necessary
    if (showElementSettings) {
      showElementSettings(e, index);
    }
  };

  // --- UI-Variablen ---
  const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
  const mainColorClass = `text-${getParamValue('mainColor', 'master')} `;
  const parallaxData = getParallaxData();

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-accordion ${shownClass}${mainColorClass}${getCssClasses()}`}
      onClick={handleShowSettings}
      style={{ ...getBackgroundStyle() }}
    >
      {getElementStyle()}

      <h2 className="p-l-20">{getParamValue('title')}</h2>

      {children ? (
        React.Children.map(children, (child, i) => {
          // We clone the child and pass on the accordion logic.
          return React.cloneElement(child, {
            accordionIndex: i,
            shownAccordionIndex,
            show: handleShowAccordion,
          });
        })
      ) : (
        <div className="p-t-15 p-b-15 text-center">
          <i className="fa fa-sort fa-4x" />
        </div>
      )}

      {getAppendHtml()}
    </div>
  );

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      <CustomScrollTrigger className="cms-overflow-fix"
        onEnter={handleShown}
        {...getCustomId()}
      >
        {parallaxData ? <Parallax {...parallaxData}>{innerContent}</Parallax> : innerContent}
      </CustomScrollTrigger>
    </div>
  );
}

export default CmsElementAccordion;
